import { type MetaFunction } from '@remix-run/node';
import { MainPage } from '~/pages/MainPage/ui/MainPage';

export const meta: MetaFunction = () => {
  return [
    {
      script: {
        src: 'https://api-maps.yandex.ru/v3/?apikey=32cddd3f-75fe-4134-9931-58b327ddfcac&lang=ru_RU',
        async: true,
      },
    },
    { title: 'ParkPay' },
    { name: 'description', content: 'ParkPay – аренда парковочных мест' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
  ];
};

export const headers = () => {
  return {
    'cache-control': 'max-age=604800, stale-while-revalidate=86400',
  };
};

// export async function loader() {
//   // Получаем данные из кэша Redis
//   const cachedData = await redis.get("some_data");

//   // если есть данные в кэше, возвращаем их
//   if (cachedData !== null && cachedData !== "") {
//     return json(JSON.parse(cachedData));
//   }

//   // Если данных в кэше нет, делаем запрос к API
//   const res = await fetcher(API.getTest, 'GET');

//   // Сохраняем полученные данные в кэш Redis на 1 час
//   await redis.set("some_data", JSON.stringify(res), "EX", 3600);

//   return res;
// }

export default function Index() {
  // const { data } = useLoaderData<typeof loader>();

  return (
    <>
      <MainPage />
    </>
  );
}
